/// <amd-module name="Repos/Views/Settings/Common/Components/ComplexToggle" />
import React = require("react");
import * as Resources from "Repos/Views/Settings/Common/Resources";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";
import { Observer } from "VSSUI/Observer";
import { Toggle } from "VSSUI/Toggle";

const baseToggleWidth = 96;
const baseTextWidth = 30;
const averageCharWidth = 10;

export interface IComplexToggleProps {
    description?: string;
    disabled?: IReadonlyObservableValue<boolean | undefined>;
    id?: string;
    isToggled?: IReadonlyObservableValue<boolean>;
    learnMoreLink?: string;
    title?: string;
    tooltip?: string;
    warningMessage?: React.ReactNode;
    warningTitle?: string;
    onToggle?(value: boolean, id?: string): void;
}

export class ComplexToggle extends VssComponent<IComplexToggleProps> {
    public constructor(props: IComplexToggleProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render = (): JSX.Element => {
        const toggleTextLength = Math.max(Resources.ToggleOn.length, Resources.ToggleOff.length);
        const textWidth = toggleTextLength * averageCharWidth;
        const currentTextWidth = baseTextWidth > textWidth ? 0 : textWidth;
        const currentWidth = currentTextWidth ? baseToggleWidth - baseTextWidth + currentTextWidth : 0;

        return (
            <Observer disabled={this.props.disabled} isToggled={this.props.isToggled}>
                {(props: { disabled: boolean | undefined; isToggled: boolean | undefined }) => {
                    return (
                        <div className="policy-toggle flex-row padding-vertical-16 padding-horizontal-20">
                            <div className="flex-column margin-right-16 padding-right-16" style={currentWidth ? { maxWidth: currentWidth } : undefined}>
                                <Toggle
                                    ariaLabel={format(
                                        Resources.ToggleFormat,
                                        this.props.title,
                                        this.props.isToggled?.value ? Resources.ToggleOn : Resources.ToggleOff
                                    )}
                                    offText={Resources.ToggleOff}
                                    onText={Resources.ToggleOn}
                                    checked={this.props.isToggled}
                                    onChange={(event, value) => {
                                        this.props.onToggle && this.props.onToggle(value, this.props.id);
                                    }}
                                    disabled={props.disabled}
                                />
                            </div>
                            <div className={"flex-column flex-grow margin-left-16 padding-horizontal-16"}>
                                <div className="flex-row flex-wrap complex-toggle-content-row">
                                    <div className="flex-column flex-grow complex-toggle-left">
                                        <h3 className="body-m margin-0 flex-row">
                                            <span className="icon-margin">{this.props.title}</span>
                                        </h3>
                                        <div className="body-s">
                                            <div className="policy-toggle-description secondary-text">
                                                {this.props.description ? this.props.description : null}
                                                {this.props.learnMoreLink ? (
                                                    <span>
                                                        {" "}
                                                        <Link
                                                            ariaLabel={
                                                                this.props.title ? format(Resources.LearnMoreAbout, this.props.title) : undefined
                                                            }
                                                            href={this.props.learnMoreLink}
                                                        >
                                                            {Resources.LearnMore}
                                                        </Link>
                                                    </span>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-column complex-toggle-right">
                                        <div className="flex-row">
                                            <div className="flex-column">
                                                {this.props.warningTitle && (
                                                    <div className="policy-toggle-icon icon-margin">
                                                        <Icon iconName={"Info"} ariaHidden={"true"} />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex-column">
                                                <div className="body-m font-weight-normal">{this.props.warningTitle}</div>
                                                <div className="body-s">
                                                    {this.props.warningMessage ? (
                                                        <div className="policy-toggle-warning secondary-text">{this.props.warningMessage}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="policy-toggle-input">{this.props.children}</div>
                            </div>
                        </div>
                    );
                }}
            </Observer>
        );
    };
}

Components.add("ms.vss-code-web.settings-common-complex-toggle-component", ComplexToggle);
